import { FunctionComponent, useEffect, useState } from 'react';
import classnames from 'classnames';

import validIcon from 'theme/icons/check_green.svg';
import invalidIcon from 'theme/icons/x_red.svg';

import { Props, Validation } from './index';
import StyledComponent from './styles';


const PublicLayoutFormsPasswordValidation: FunctionComponent<Props> = ({
    password,
    translations,
    pwdLength,
    checkIfValid,
}) => {
    const length = new RegExp(`^.{${pwdLength || 8},}$`);
    const lowercase = new RegExp(/[a-z]/);
    const uppercase = new RegExp(/[A-Z]/);
    const digits = new RegExp(/\d/);
    const symbols = new RegExp(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/);


    const [validation, setValidation]: [Validation, Function] = useState(null);
    useEffect(() => {
        const pass = password || '';
        const newValidation:Validation = {
            length: length.test(pass),
            lowercase: lowercase.test(pass),
            uppercase: uppercase.test(pass),
            digits: digits.test(pass),
            symbols: symbols.test(pass),
        };
        setValidation(newValidation);
        checkIfValid(newValidation);
    }, [password]);


    const setInvalidClass = (testName:string, pwdTests:Validation): boolean => {
        if(!pwdTests) return false;
        return !pwdTests[testName];
    };
    const calculateProgressBarFill = () => {
        let validationLength;

        if(validation === null) {
            validationLength = 0;
        } else {
            const passedTests = Object.values(validation).filter(val=>
                val === true
            );
            validationLength = passedTests.length;
        }
        const percent = (Math.round((validationLength / translations?.length) * 100));
        if(percent > 0 && percent < 50) {
            return 25;
        } else if (percent >= 50 && percent < 75) {
            return 50;
        } else if (percent >= 75 && percent < 100 ) {
            return 75;
        } else if(percent === 100) {
            return 100;
        } else {
            return 0;
        }
    };

    const progressPercent = calculateProgressBarFill();

    return (
        <StyledComponent className="public-layout-forms-password-validation"  >

            <div className='progressbar'>
                <span
                    className={`progress-stage progress-${progressPercent}`}
                    style={{
                        width: `${progressPercent}%`,
                    }}
                />


            </div>
            {translations && translations.map(validationEl=>(
                <p
                    className={classnames(
                        'validation-el',
                        {
                            'invalid': setInvalidClass(validationEl.name, validation),
                        }
                    )}
                    key={validationEl.name}
                >
                    <img
                        src={validIcon}
                        alt=""
                        className="validation-img valid-icon"
                        loading="lazy"
                    />
                    <img
                        src={invalidIcon}
                        alt=""
                        className="validation-img invalid-icon"
                        loading="lazy"
                    />
                    <span className="validation-txt">{validationEl.value}</span>
                </p>
            ))}

        </StyledComponent>
    );
};

export default PublicLayoutFormsPasswordValidation;